import { Button, RiSaveLine, TextLink } from "@itandi/itandi-bb-ui";
import { useRouter } from "next/router";
import React from "react";
import { useFormContext } from "react-hook-form";
import { toast } from "react-toastify";
import useLoader from "~/hooks/useLoader";
import type { DealParam } from "~/models/DealForm";
import { PATH } from "~/pages/deals/[id]";
import { isSuccess } from "~/utils/api/api_handler";
import { create } from "~/utils/api/Deal";
import { onInvalidScroll } from "~/utils/FormUtil";
import Styles from "./DealEditorFooter.module.scss";

export const DealEditorFooter: React.FC = () => {
	const router = useRouter();
	const { getValues, handleSubmit } = useFormContext<DealParam>();
	const { Loader, showLoader, hideLoader } = useLoader();
	const onClickSubmit = React.useCallback(() => {
		handleSubmit(
			async () => {
				showLoader();
				const response = await create(getValues());
				if (isSuccess(response) && response.data?.id != null) {
					await router.push(PATH(response.data.id));
					hideLoader();
					toast.success("作成しました");
					return;
				}
				hideLoader();
				toast.error("エラーが発生しました");
			},
			(errors) => {
				onInvalidScroll(errors);
			}
		)();
	}, [handleSubmit, showLoader, getValues, hideLoader, router]);
	const { leasing_id: leasingId } = router.query;
	return (
		<div className={Styles.DealEditorFooter}>
			<Loader />
			{leasingId ? (
				<TextLink
					color="link"
					href={`${process.env.NEXT_PUBLIC_ITANDIBB_SERVICES_KT}/leasings/${leasingId}`}
					size="s"
					target="_blank"
				>
					入居者管理に戻る
				</TextLink>
			) : null}
			<Button
				className={Styles.SaveButton}
				onClick={onClickSubmit}
				startIcon={<RiSaveLine className={Styles.Icon} />}
				variant="primary"
			>
				保存
			</Button>
		</div>
	);
};
